import React from "react";
import { Field } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { Typography } from "@material-ui/core";

import Form from "components/form";
import { NoteInput } from "components/inputs/text-input";
import { RequestInfoIcon } from "helpers/icon-finder";

const UpdateApplicationStatusForm = ({
  applicationId,
  onSucceed,
  changeStatus,
  submitLabel,
  onSubmit,
  helperText,
  orgUnitId,
  required = false,
  title,
  ...other
}) => {
  const dispatch = useDispatch();
  const reasonLabel = `Reason to ${title || "Change Status"}`;
  const schema = Yup.object().shape({
    applicationStatus: Yup.object().shape({
      reason: (required
        ? Yup.string()
          .required(`${reasonLabel} is required.`)
          .max(500, `${reasonLabel} can only be up to 500 characters.`)
        : Yup.string()
          .max(500, `${reasonLabel} can only be up to 500 characters.`)
          .nullable()),
    }),
  });
  const { applicationStatus } = schema.cast();

  const handleSubmit = (data, { setErrors }) => {
    dispatch(onSubmit(applicationId, data.applicationStatus, orgUnitId)).then(response => {
      if (response.error !== true) {
        onSucceed();
      } else {
        setErrors(response.payload);
      }
    });
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{ applicationStatus }}
      validationSchema={schema}
      contentProps={{ ...other, submitLabel: submitLabel || "Submit" }}
      content={() => (
        <>
          {helperText && <Typography className="ml-24">{helperText}</Typography>}
          <Field
            name="applicationStatus.reason"
            component={NoteInput}
            label={reasonLabel}
            icon={<RequestInfoIcon />}
            maxLength={500}
            required={required}
          />
        </>
      )}
    />
  );
};

export default UpdateApplicationStatusForm;
